import { RegistPage } from './../pages/regist/regist';
import { VrAccountSearchPage } from './../pages/vraccountreport/search';
import { VraccountreportPage } from './../pages/vraccountreport/vraccountreport';
import { VrProfitSearchPage } from './../pages/vrprofitreport/search';
import { VrprofitreportPage } from './../pages/vrprofitreport/vrprofitreport';
import { ChaseOrderDetailPage } from './../pages/vrchasereport/chaseorderdetail';
import { ChaseSearchPage } from './../pages/vrchasereport/search';
import { VrchasereportPage } from './../pages/vrchasereport/vrchasereport';
import { GameOrderDetailPage } from './../pages/vrgamereport/gameorderdetail';
import { GameSearchPage } from './../pages/vrgamereport/search';
import { VrgamereportPage } from './../pages/vrgamereport/vrgamereport';
import { RechargeHuiTianFu } from './../pages/recharge/huitianfu/huitianfu';
import { RechargeIFee } from './../pages/recharge/ifee/ifee';
import { RechargeYiBao } from './../pages/recharge/yibao/yibao';
import { SignalrService } from './../providers/signalr.service';
import { SignalRModule, SignalRConfiguration } from 'ng2-signalr';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler, MenuToggle } from 'ionic-angular';
import { LegendApp } from './app.component';
import { AppConfig } from './app.config';
import { AccountPage } from '../pages/account/account';
import { WeiXinPage } from '../pages/account/weixin';
import { LotteryOpenPage } from '../pages/lotteryopen/lotteryopen';
import { HomePage } from '../pages/home/home';
import { PromotionPage } from '../pages/promotion/promotion';
import { PromotionDetail } from '../pages/promotion/promotiondetail';
import { SigninPage } from '../pages/signin/signin';
import { AgreeMsg } from '../pages/signin/agreemsg';
import { Realm } from '../pages/signin/realm';
import { LotteryAllPage } from '../pages/lottery-all/lottery-all';
import { RechargePage } from '../pages/recharge/recharge';
import { RechargeMain } from '../pages/recharge/rechargemain';
import { RechargeHeBao } from './../pages/recharge/hebao/hebao';
import { RechargeMiaoKaTong } from './../pages/recharge/miaokatong/miaokatong';
import { RechargeHuiBoWY } from './../pages/recharge/huibowy/huibowy';
import { RechargeJiFu } from './../pages/recharge/jifu/jifu';
import { DepositRecordPage } from '../pages/deposit-record/deposit-record';
import { Depositsearch } from '../pages/deposit-record/depositsearch';
import { TransferPage } from '../pages/transfer/transfer';
import { TransferRecordPage } from '../pages/transfer-record/transfer-record';
import { TransferSearch } from '../pages/transfer-record/transfersearch';
import { WithdrawPage } from '../pages/withdraw/withdraw';
import { WithdrawKeyPage } from '../pages/withdraw/withdrawKey';
import { WithdrawRecordPage } from '../pages/withdraw-record/withdraw-record';
import { WithdrawSearch } from '../pages/withdraw-record/withdrawsearch';
import { OpenList } from '../pages/lotteryopen/list/openlist';
import { PageDefault } from '../pages/PageDefault';
import { SelfReport } from '../pages/selfreport/selfreport';
import { SelfreportSearch } from '../pages/selfreport/selfreportsearch';
import { AccountChange } from '../pages/accountchange/accountchange';
import { AccountSearch } from '../pages/accountchange/accountsearch';
import { ChaseReport } from '../pages/chasereport/chasereport';
import { ChaseSearch } from '../pages/chasereport/chasesearch';
import { DailyWagesReport } from '../pages/dailywagesreport/dailywagesreport';
import { DailywagesetPage } from '../pages/dailywageset/dailywageset';
import { SetDailyWagesPage } from '../pages/dailywageset/setdailywages';
import { AddDailyWagesPage } from '../pages/dailywageset/adddailywages';
import { DailyWageSearch } from '../pages/dailywagesreport/dailywagesearch'
import { NormalReport } from '../pages/normalreport/normalreport';
import { NormalSearch } from '../pages/normalreport/normalsearch';
import { TeamReport } from '../pages/teamreport/teamreport';
import { TeamSearch } from '../pages/teamreport/teamsearch';
import { ChangeBonus } from '../pages/teammanager/changebonus';
import { UserLimits } from '../pages/teammanager/userLimits';
import { Deposit } from '../pages/teammanager/deposit';
import { OutboxPage } from '../pages/outbox/outbox';
import { OutboxSearch } from '../pages/outbox/outboxsearch';
import { InboxPage } from '../pages/inbox/inbox';
import { InboxSearch } from '../pages/inbox/inboxsearch';
import { SecretquestionPage } from '../pages/secretquestion/secretquestion';
import { RechargeWx } from '../pages/recharge/rechargewx'

import { SendMessagePage } from '../pages/send-message/send-message';
import { BettingOrderPage } from '../pages/bettingorder/bettingorder';
import { BettingOrderAdd } from '../pages/bettingorder/bettingorderadd';
import { BettingChase } from '../pages/bettingorder/bettingchase';
import { RewardPage } from '../pages/bettingorder/reward';
import { PlaySelectPage } from '../pages/bettingorder/playSelect';
import { DollarsPage } from '../pages/dollars/dollars';
import { BettingListPage } from '../pages/dollars/bettingList';
import { ActivityPage } from '../pages/activity/activity';
import { PasswordPage } from '../pages/password/password';
import { ScancodePage } from '../pages/scancode/scancode';
import { RevisePage } from '../pages/password/revise';
import { ReviseMoneyPage } from './../pages/password/reviseMoney';
import { UserMoneyPage } from '../pages/bettingorder/reward';


import { TeamManagerList } from '../pages/teammanager/teammanager';
import { TeamManagerSearch } from '../pages/teammanager/teammanagersearch';
import { UserBankList } from '../pages/userbanks/userbanklist';
import { AddUserBank } from '../pages/userbanks/adduserbank';
import { OpenAccountPage } from '../pages/open-account/open-account';
import { TabsPage } from '../pages/tabs/tabs';
import { NgPipesModule } from 'ng-pipes';

import { OrderDetailDirective, OrderDetailComponent } from '../dires/orderdetail/orderdetail.directive';
import { RevocationDirective } from '../dires/revocation/revocation.directive';
import { MsgDetailDirective, MsgDetailComponent } from '../dires/msgdetail/msgdetail.diretive';
import { CopyDirective } from './../dires/copy/copy.diretive';
import { LoaddingService } from '../providers/loadding.service';
import { AlertService } from '../providers/alert.service';
import { ToastService } from '../providers/toast.service';
import { HttpService } from '../providers/http.service';
import { StorageService } from '../providers/storage.service';
import { AuthService } from '../providers/auth.service';

import { Title, BrowserModule } from '@angular/platform-browser';
import { InAppBrowser } from "@ionic-native/in-app-browser";
// import { CookieModule } from 'ngx-cookie';

import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { Http, HttpModule, RequestOptions } from '@angular/http';
import { CommonService } from '../services/common.service';
import { SigninService } from '../services/signin.service';
import { WechatPage } from '../pages/wechat/wechat';
import { WechatBindPage } from '../pages/wechat/wechatbind';
import { WechatUnBindPage } from '../pages/wechat/wechatunbind';
import { WechatRegistPage } from '../pages/wechat/wechatregist';
import { PlaySelectService } from '../services/playselect.service';

import { KaiYuanService } from '../services/kaiyuan.service';
import { EbetService } from '../services/ebet.service';
import { GooglePage } from '../pages/google/google';

import { ChatService } from '../services/chat.service';
import { ImPage } from '../pages/im/im';
import { FriendListPage } from '../pages/im/friend-list';
import { ChatDetailsPage } from '../pages/im/chat-details';
import { EmojiService } from '../services/emoji.service';
import { GamMaService } from '../services/gamMa.service';
import { BrickTrendPage } from '../pages/lotteryopen/brick-trend/brick-trend';
import { BrickTrendScreen } from '../pages/lotteryopen/brick-trend/brick-trend-screen/brick-trend-screen';
import { ImGamingService } from '../services/imgaming.service';
import { SubDigetPipe } from '../pipe/subDiget.pipe';
import { FixedExtend } from '../config/fixed-extend';
import { ShaBaService } from '../services/shaba.service';
import { BrowserPage } from '../pages/browser/browser';
import { ContinuePage } from '../pages/normalreport/continue';
import { NormalReportService } from '../services/normalreport.service';
import { BettingService } from '../services/betting.service';
import { MaintainPage } from '../pages/maintain/maintain';
import { OpenAccountSearch } from '../pages/open-account/openaccountsearch';
import { QRCodeModule } from 'angular2-qrcode';
import { SuperTabsModule } from 'ionic2-super-tabs';
import { YaBoLiveService } from '../services/yabolive.service';
import { YaBoService } from '../services/yabo.service';
import { ContinueBettingPage } from '../pages/normalreport/continue-betting';
import { slideBlockCommon } from '../pages/signin/slide-block/slideBlock';
import { SliderCaptchaPage } from '../pages/signin/slider-captcha/slider-captcha';
import { DaikeModalPage } from '../pages/daike-modal/daike-modal';
import { DaikeWindowPage } from '../pages/daike-window/daike-window';
import { DomainsPage } from '../pages/domains/domains';
import { PgPage } from '../pages/home/pg/pg';
import { LinkCollectionPage } from '../pages/link-collection/link-collection';
import { BettingParamService } from '../services/betting.param.service';
import { NewMaintainPage } from '../pages/new-maintain/maintain';


export function createConfig(): SignalRConfiguration {
    const c = new SignalRConfiguration();
    c.hubName = 'legendHub';
    c.qs = { "Authorization": "Bearer" };
    c.logging = false;
    return c;
}


export function authHttpServiceFactory(http: Http, options: RequestOptions) {
    return new AuthHttp(new AuthConfig({ noJwtError: true }), http, options);
}

@NgModule({
    declarations: [
        LegendApp,
        AccountPage,
        ActivityPage,
        WeiXinPage,
        LotteryOpenPage,
        HomePage,
        PromotionPage,
        PromotionDetail,
        TabsPage,
        SigninPage,
        AgreeMsg,
        LotteryAllPage,
        OpenList,
        SelfReport,
        SelfreportSearch,
        RechargePage,
        RechargeHeBao,
        RechargeMiaoKaTong,
        RechargeHuiBoWY,
        RechargeJiFu,
        RechargeIFee,
        RechargeHuiTianFu,
        DepositRecordPage,
        TransferPage,
        TransferRecordPage,
        WithdrawPage,
        WithdrawRecordPage,
        AccountChange,
        ChaseReport,
        DailyWagesReport,
        NormalReport,
        TeamReport,
        OrderDetailDirective,
        OrderDetailComponent,
        RevocationDirective,
        MsgDetailDirective,
        MsgDetailComponent,
        CopyDirective,
        NormalSearch,
        ChaseSearch,
        TeamSearch,
        DailyWageSearch,
        UserLimits,
        Deposit,
        TeamManagerList,
        TeamManagerSearch,
        UserBankList,
        AddUserBank,
        WithdrawKeyPage,
        RechargeMain,
        OpenAccountPage,
        ChangeBonus,
        Depositsearch,
        AccountSearch,
        WithdrawSearch,
        TransferSearch,
        OutboxPage,
        OutboxSearch,
        InboxPage,
        InboxSearch,
        SendMessagePage,
        BettingOrderPage,
        BettingOrderAdd,
        BettingChase,
        RewardPage,
        PlaySelectPage,
        DollarsPage,
        BettingListPage,
        PasswordPage,
        ScancodePage,
        RevisePage,
        SecretquestionPage,
        ReviseMoneyPage,
        Realm,
        DailywagesetPage,
        SetDailyWagesPage,
        AddDailyWagesPage,
        RechargeYiBao,
        UserMoneyPage,
        VrgamereportPage,
        GameSearchPage,
        GameOrderDetailPage,
        VrchasereportPage,
        ChaseSearchPage,
        ChaseOrderDetailPage,
        VrprofitreportPage,
        VrProfitSearchPage,
        VraccountreportPage,
        VrAccountSearchPage,
        RegistPage,
        RechargeWx,
        WechatPage,
        WechatBindPage,
        WechatUnBindPage,
        WechatRegistPage,
        GooglePage,
        ImPage,
        FriendListPage,
        ChatDetailsPage,
        BrickTrendPage,
        BrickTrendScreen,
        SubDigetPipe,
        BrowserPage,
        ContinuePage,
        MaintainPage,
        OpenAccountSearch,
        ContinueBettingPage,
        slideBlockCommon,
        SliderCaptchaPage,
        DaikeModalPage,
        DaikeWindowPage,
        DomainsPage,
        PgPage,
        LinkCollectionPage,
        NewMaintainPage,
    ],
    imports: [
        // CookieModule.forRoot(),
        BrowserModule,
        HttpModule,
        NgPipesModule,
        QRCodeModule,
        SuperTabsModule.forRoot(),
        SignalRModule.forRoot(createConfig),
        IonicModule.forRoot(LegendApp, {
            backButtonText: '',
            iconMode: 'ios',
            modalEnter: 'modal-slide-in',
            modalLeave: 'modal-slide-out',
            tabsPlacement: 'bottom',
            pageTransition: 'ios'
        }, { links: [] }),

    ],
    bootstrap: [IonicApp],
    entryComponents: [
        LegendApp,
        AccountPage,
        ActivityPage,
        WeiXinPage,
        LotteryOpenPage,
        HomePage,
        PromotionPage,
        PromotionDetail,
        TabsPage,
        SigninPage,
        AgreeMsg,
        LotteryAllPage,
        OpenList,
        SelfReport,
        SelfreportSearch,
        RechargePage,
        RechargeHeBao,
        RechargeMiaoKaTong,
        RechargeYiBao,
        RechargeHuiBoWY,
        RechargeJiFu,
        RechargeIFee,
        RechargeHuiTianFu,
        DepositRecordPage,
        TransferPage,
        TransferRecordPage,
        WithdrawPage,
        WithdrawRecordPage,
        AccountChange,
        ChaseReport,
        DailyWagesReport,
        NormalReport,
        TeamReport,
        OrderDetailComponent,
        MsgDetailComponent,
        NormalSearch,
        ChaseSearch,
        TeamSearch,
        DailyWageSearch,
        UserLimits,
        Deposit,
        TeamManagerList,
        TeamManagerSearch,
        UserBankList,
        AddUserBank,
        WithdrawKeyPage,
        RechargeMain,
        OpenAccountPage,
        ChangeBonus,
        Depositsearch,
        AccountSearch,
        WithdrawSearch,
        TransferSearch,
        OutboxPage,
        OutboxSearch,
        InboxPage,
        InboxSearch,
        SendMessagePage,
        BettingOrderPage,
        BettingOrderAdd,
        BettingChase,
        RewardPage,
        PlaySelectPage,
        DollarsPage,
        BettingListPage,
        PasswordPage,
        ScancodePage,
        RevisePage,
        SecretquestionPage,
        ReviseMoneyPage,
        DailywagesetPage,
        SetDailyWagesPage,
        AddDailyWagesPage,
        Realm,
        UserMoneyPage,
        VrgamereportPage,
        GameSearchPage,
        GameOrderDetailPage,
        VrchasereportPage,
        ChaseSearchPage,
        ChaseOrderDetailPage,
        VrprofitreportPage,
        VrProfitSearchPage,
        VraccountreportPage,
        VrAccountSearchPage,
        RechargeWx,
        RegistPage,
        WechatPage,
        WechatBindPage,
        WechatUnBindPage,
        WechatRegistPage,
        GooglePage,
        ImPage,
        FriendListPage,
        ChatDetailsPage,
        BrickTrendPage,
        BrickTrendScreen,
        BrowserPage,
        ContinuePage,
        MaintainPage,
        OpenAccountSearch,
        ContinueBettingPage,
        slideBlockCommon,
        SliderCaptchaPage,
        DaikeModalPage,
        DaikeWindowPage,
        DomainsPage,
        PgPage,
        LinkCollectionPage,
        NewMaintainPage,
    ],
    providers: [
        SplashScreen,
        StatusBar,
        InAppBrowser,
        { provide: ErrorHandler, useClass: IonicErrorHandler },
        HttpService,
        SignalrService,
        StorageService,
        LoaddingService,
        AlertService,
        ToastService,
        AppConfig,
        PageDefault,
        AuthService,
        MenuToggle,
        Title,
        {
            provide: AuthHttp,
            useFactory: authHttpServiceFactory,
            deps: [Http, RequestOptions]
        },
        CommonService,
        SigninService,
        PlaySelectService,
        KaiYuanService,
        EbetService,
        ChatService,
        EmojiService,
        GamMaService,
        ImGamingService,
        FixedExtend,
        ShaBaService,
        NormalReportService,
        BettingService,
        BettingParamService,
        YaBoService,
        YaBoLiveService
    ],
    exports:[
      SubDigetPipe
    ]
})

export class AppModule {

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts